const publicMessage = () => {
  let publicMessageEl = document.querySelector('.public-message')
  if (!publicMessageEl) return

  let message = JSON.parse(publicMessageEl.dataset.message)
  if (localStorage[`public-message-${message.id}`] == 'shown') return

  if ($.magnificPopup.instance.isOpen) $.magnificPopup.instance.close()

  let content = `
    <div class="white-popup-block public-message">
      ${message.content}

      <a href="#" class="btn big red mb-0" onclick="$.magnificPopup.instance.close(); return false;">
        Close
      </a>
    </div>
  `

  $.magnificPopup.open({
    items: {
      src: content,
      type: 'inline'
    },
    closeOnContentClick: false,
    closeOnBgClick: false,
    alignTop: true
  })

  localStorage[`public-message-${message.id}`] = 'shown'
}

export default publicMessage;